import React from 'react'
import ReactCountryFlag from 'react-country-flag'

function TopTenCases({MyLocalData, LoadingState}) {
  const getData = () => {
    if (!LoadingState) {
      const sortedData = [...MyLocalData]
      sortedData.sort((a, b) => {
        let comp = 0
        a.TotalConfirmed < b.TotalConfirmed ? (comp = 1) : (comp = -1)
        return comp
      })
      return sortedData.slice(0, 10)
    }
  }
  const tableData = React.useMemo(() => getData(), [LoadingState])
  return (
    <div className="global-box d-flex flex-column align-items-center mt-5">
      <div className="global-title d-flex">
        <label className="top-ten">
          Top ten countries with heighest number of cases
        </label>
      </div>
      <table className="table table-striped table-hover table-bordered table-sm table-responsive-sm">
        <thead className="text-light align-items-center">
          <tr>
            <th className="rank ">Rank</th>
            <th className="flag">Flag</th>
            <th className="con">Country</th>
            <th className="cnf">Confirmed</th>
            <th className="act">Active</th>
            <th className="rcv">Recovered</th>
            <th className="dea">Deaths</th>
          </tr>
        </thead>
        <tbody>
          {!LoadingState &&
            tableData.map((item, i) => {
              return (
                <tr key={i}>
                  <td className="data-id">{i + 1}</td>
                  <td className="data-flag">
                    <ReactCountryFlag
                      countryCode={item.CountryCode}
                      svg
                      style={{fontSize: '3em', lineHeight: '3em'}}
                      title={item.Country}
                    />
                  </td>
                  <td className="data-country">{item.Country}</td>
                  <td className="data-cnf">
                    <sup> ↑{item.NewConfirmed}</sup>
                    <br />
                    {item.TotalConfirmed}
                  </td>
                  <td className="data-act">
                    {item.TotalConfirmed -
                      item.TotalRecovered -
                      item.TotalDeaths}
                  </td>
                  <td className="data-rcv">
                    <sup> ↑{item.NewRecovered}</sup>
                    <br />
                    {item.TotalRecovered}
                  </td>
                  <td className="data-dea">
                    <sup> ↑{item.NewDeaths}</sup>
                    <br />
                    {item.TotalDeaths}
                  </td>
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  )
}

export default TopTenCases
